import { Snackbar } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { FC } from 'react';

import { Alert, AlertType } from '@abg/kit-base';

import { SnackBarStyles } from './notification.styling';
import { NotificationTypes } from './notification.types';

export const Notification: FC<NotificationTypes> = (props) => {
  const {
    closable = false,
    withIcon = false,
    level,
    type,
    title,
    description,
    icon,
    onClose = () => {},
    sx,
    autoHideDuration = 5000,
  } = props;

  return (
    <Snackbar
      open
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={mergeSx(SnackBarStyles, sx)}
    >
      <Alert
        open={true}
        closable={closable}
        withIcon={withIcon}
        onClose={onClose}
        customIcon={icon}
        level={level || 4}
        type={type || AlertType.INFORMATION}
        title={title}
        description={description}
      />
    </Snackbar>
  );
};
